<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.userName"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="tableList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :total-amount="totalAmount"
          :is-show-total="isShowTotal"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @addBill="addBillFun()"
          @editBill="editBillFun(arguments)"
          @removeBill="removeBillFun(arguments)"
          @checkBill="checkBillFun(arguments)"
          @uncheckBill="uncheckBillFun(arguments)"
          @viewBill="viewBillFun(arguments)"
          @dblclick="viewBillFun(arguments)"
          @export="batchExport(tableList)"
          @getTotal="totalFun"
        />
      </div>
      <!-- 操作-->
      <add-edit-view-dialog
        :data-id="billId"
        :event-type="eventType"
        :user-id="userId"
        :user-name="userName"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 新增修改查看
import addEditViewDialog from './addEditViewDialog'
import { loadExpenseLoanListListDataApi, loadExpenseLoanListExportDataApi, saveOrUpdateExpenseLoanListApi } from '@/api/expenseLoanList'
export default {
  name: 'ExpenseLoanInfoList',
  components: { CustomTable, addEditViewDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin, batchExportMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    userId: {
      type: Number,
      default: null
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'expense_loan_info_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['expense_loan_add'],
            prop: 'add',
            label: '新增',
            method: 'addBill'
          },
          {
            permissionSigns: ['expense_loan_edit'],
            prop: 'edit',
            label: '修改',
            method: 'editBill'
          },
          {
            permissionSigns: ['expense_loan_del'],
            prop: 'del',
            label: '作废',
            method: 'removeBill'
          },
          {
            prop: 'view',
            label: '查看',
            method: 'viewBill'
          },
          {
            permissionSigns: ['expense_loan_check'],
            prop: 'check',
            label: '复核',
            method: 'checkBill'
          },
          {
            permissionSigns: ['expense_loan_uncheck'],
            prop: 'uncheck',
            label: '反复核',
            method: 'uncheckBill'
          },
          {
            permissionSigns: ['expense_loan_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            statusName: '',
            status: ''
          }
        }
      },
      isPaging: true,
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      billId: null,
      statusOptions: [{ data: 1, label: '制单' }, { data: 2, label: '复核' }],
      totalAmount: 0, // 合计结果
      isShowTotal: false // 合计显示
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.tableQuery.search.userId = null
        this.tableList.initTableColumn = [
          { prop: 'userName', label: '借款/还款人', filterColumn: 'user_name', width: 120 },
          { prop: 'typeStr', label: '类型', filterColumn: 'type', filterValue: 'type', width: 120, filterArray: [{ label: '借款', value: 1 }, { label: '还款', value: 2 }, { label: '报销冲抵', value: 3 }] },
          { prop: 'happenDateStr', label: '借款/还款日期', filterColumn: 'happen_date', width: 140 },
          { prop: 'amountValue', label: '金额', filterColumn: 'if(type = 1,amount,0-amount)',allowSum: true,formatPrice: true, width: 120, align: 'right' },
          { prop: 'purpose', label: '用途', filterColumn: 'purpose', width: 120 },
          { prop: 'statusStr', filterColumn: 'status', filterValue: 'status', label: '状态', width: 100, filterArray: [{ label: '制单', value: 1 }, { label: '复核', value: 2 }] },
          { prop: 'remark', filterColumn: 'remark', label: '备注', width: 260 },
          { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 150 },
          { prop: 'createTimeStr', filterColumn: 'create_time', label: '创建时间', width: 160, isBetween: true },
          { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 150 },
          { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 160, isBetween: true }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        if (this.userName !== '') {
          this.tableList.tableQuery.search.userId = this.userId
        }
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.isShowTotal = false
      this.totalAmount = 0
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadExpenseLoanListListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        data.forEach(item => {
          if(item.status === 1){
            item.fontColor = 'orange'
          } else if (item.type === 1){
            item.fontColor = 'red'
          } else if (item.type === 2 || item.type === 3){
            item.fontColor = 'blue'
          }
        })
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      this.tableList.tableLoading = true
      let sumCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      sumCondition.isSumTotal = true
      sumCondition.sumField = computedTotalObj.filterColumn
      loadExpenseLoanListListDataApi(sumCondition).then(response => {
        this.tableList.tableLoading = false
        this.isShowTotal = true
        this.totalAmount = response.data ? response.data.sumTotal : 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 新增
    addBillFun () {
      this.billId = null
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增借款/还款单'
    },
    // 修改
    editBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在制单状态，不能修改',
          type: 'warning'
        })
        return false
      }
      this.billId = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改借款/还款单'
    },
    // 查看
    viewBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else {
        this.billId = args[0].id
        this.eventType = 'view'
        this.dialogAddEditVisible = !this.dialogAddEditVisible
        this.dialogAddEditTitle = '查看借款/还款单'
      }
    },
    // 作废
    removeBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在制单状态，不能作废',
          type: 'warning'
        })
        return false
      }
      this.$confirm('是否确定作废该数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateExpenseLoanListApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else if (args[0].status !== 1) {
        this.$message({
          message: '数据不在制单状态，不能复核',
          type: 'warning'
        })
        return false
      }
      this.$confirm('是否确定复核该数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateExpenseLoanListApi({ id: args[0].id, isCheck: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
    // 反复核
    uncheckBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else if (args[0].status !== 2) {
        this.$message({
          message: '数据不在复核状态，不能反复核',
          type: 'warning'
        })
        return false
      }
      this.$confirm('是否确定反复核该数据？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateExpenseLoanListApi({ id: args[0].id, isUnCheck: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.reloadMasterData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadExpenseLoanListExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
